import { CustomerRepository } from "../../repositories/CustomerRepository";
import {
  CustomerOperationResult,
  CustomerEntity,
} from "../../entities/CustomerEntity";

/**
 * Update Customer Use Case
 * Updates an existing customer's information
 */
export class UpdateCustomerUseCase {
  constructor(private repository: CustomerRepository) {}

  async execute(
    customerId: string,
    customerData: Partial<CustomerEntity>
  ): Promise<CustomerOperationResult> {
    // Validate customer ID
    return await this.repository.updateCustomer(customerId, customerData);
  }
}
